import React, { useEffect, useState } from "react";
import BlogWrite from "../../components/Blog/BlogWrite";
import BlogHelp from "../../components/Blog/BlogHelp";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { BlogProperty } from "../../types/blogType";

const NewBlog = () => {
	const { pathname } = useLocation();
	const [content, setContent] = useState<BlogProperty | null>(null);

	useEffect(() => {
		if (pathname === "/blog/new") return;
		const fetchData = async () => {
			await axios
				.get(`/api/blog/${pathname.split("/")[2]}`)
				.then(({ data }) => {
					setContent(data.data);
				})
				.catch((err) => {
					console.error(err);
				});
		};
		fetchData();
	}, [pathname]);

	return (
		<div id="blog-new">
			<BlogHelp />
			<BlogWrite data={content || null} type={content ? "edit" : "new"} />
		</div>
	);
};

export default NewBlog;
